import { Box, Button, Dialog, DialogTitle, Typography } from "@mui/material";
import AttachmentFilterSection from "components/extra-filters/attachment-filter";
import HorsePowerSection from "components/extra-filters/horse-power";
import MoreSection from "components/extra-filters/sections/more";
import PriceSection from "components/extra-filters/sections/price";
import TractorFilterSection from "components/extra-filters/tractor-filter";
import MapViewOption from "components/search-filters/map-view-option";
import { useState } from "react";
import Switch from "react-ios-switch";
import {
  clearSearchFilters,
  setInstantBooking,
  setPrices,
  setSearchFilters,
} from "slices/searchListingReducer";
import { useAppDispatch, useAppSelector } from "store/appHooks";

const AllFilters = ({ onClose }: { onClose: any }) => {
  const { prices, filters, instantBooking } = useAppSelector(
    (state) => state.searchListingReducer
  );
  const [price, setPrice] = useState(prices);
  const [filts, setFilters] = useState(filters);
  const dispatch = useAppDispatch();

  const applyAllFilters = () => {
    dispatch(setPrices(price));
    dispatch(setSearchFilters(filts));
    onClose();
  };

  return (
    <Dialog open fullScreen onClose={onClose}>
      <Box
        sx={{
          borderBottom: "1px solid #E2E2E2",
          px: "4%",
          py: "20px",
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
        }}
      >
        <Typography
          sx={{
            fontSize: "18px",
            fontWeight: 600,
            lineHeight: "22px",
          }}
        >
          Filters
        </Typography>

        <img
          src="/assets/img/icons/close_square.svg"
          alt=""
          onClick={onClose}
        />
      </Box>

      <Box
        sx={{
          borderBottom: "8px solid #F7F7F7",
          px: "4%",
          py: "20px",
          display: "flex",
          flexDirection: "column",
          gap: "20px",
        }}
      >
        <MapViewOption />

        <Box
          sx={{
            border: "1px solid #E2E2E2",
            borderRadius: "10px",
            px: "20px",

            display: "flex",
            alignItems: "center",
            gap: "10px",
            height: "64px",

            // width: "100%",
          }}
        >
          <Typography
            sx={{
              color: "#323232",
              fontSize: "15px",
              lineHeight: "17.66px",
              fontFamily: "gilroy-medium",
              fontWeight: 500,
            }}
          >
            Looking for Instant Booking?
          </Typography>
          <Box
            sx={{
              display: "flex",
              justifyContent: "flex-end",
              flex: 1,
            }}
          >
            <Switch
              checked={instantBooking}
              onChange={() => dispatch(setInstantBooking(!instantBooking))}
            />
          </Box>
        </Box>
      </Box>
      <Box
        sx={{
          px: "4%",
          borderBottom: "8px solid #F7F7F7",
          py: "20px",
          display: "flex",
          flexDirection: "column",
          gap: "10px",
        }}
      >
        <Typography
          sx={{
            fontWeight: 600,
            fontSize: "16px",
            lineHeight: "34px",
            color: "#323232",
          }}
        >
          Type
        </Typography>
        <HorsePowerSection selectionBox={true} onClose={() => {}} />
        <TractorFilterSection selectionBox={true} onClose={() => {}} />
        <AttachmentFilterSection selectionBox={true} onClose={() => {}} />
      </Box>
      <Box
        sx={{
          borderBottom: "8px solid #F7F7F7",
          px: "4%",
          py: "20px",
          display: "flex",
          flexDirection: "column",
          gap: "20px",
        }}
      >
        <PriceSection values={price} onChange={setPrice} />
      </Box>
      <MoreSection value={filts} onChange={setFilters} />

      <Box
        sx={{
          display: "flex",
          gap: "10px",
          py: "10px",
          justifyContent: "center",
        }}
      >
        <Button
          color="error"
          size="large"
          onClick={() => {
            setPrice([0, 10000]);
            setFilters({});
            dispatch(clearSearchFilters());
          }}
        >
          Clear All
        </Button>
        <Button
          color="primary"
          size="large"
          variant="contained"
          onClick={applyAllFilters}
        >
          Apply Filter
        </Button>
      </Box>
    </Dialog>
  );
};

export default AllFilters;
